export enum MeetingId {
  AYNJ_UK_VISA_INTAKE = 'aynj_uk_visa_intake',
  MSP_CLIENT_INTAKE = 'msp_client_intake',
  LODESTONE_LEGAL_INTAKE = 'lodestone_legal_intake',
  IMIGRATA_DIGITAL_NOMAD_INTAKE = 'imigrata_digital_nomad_intake',
  ERUM_US_IMMIGRATION_INTAKE = 'erum_us_immigration_intake',
  PRINCEVISA_INTAKE = 'princevisa_intake',
  VISA_ARCHITECT_INTAKE = 'visa_architect_intake',
  BWEA_US_IMMIGRATION_INTAKE = 'bwea_us_immigration_intake',
}

interface MeetingReportUIConfig {
  showVoiceWhatsappToggle: boolean;
  defaultReportType: 'voice' | 'whatsapp';
  showExportCsv: boolean;
  showCallTypeColumn: boolean;
  showVisaCategoryColumn: boolean;
  showVisaCategorySection: boolean;
  showVisaCategoriesSection: boolean;
}

const defaultConfig: MeetingReportUIConfig = {
  showVoiceWhatsappToggle: true,
  defaultReportType: 'voice',
  showExportCsv: true,
  showCallTypeColumn: true,
  showVisaCategoryColumn: true,
  showVisaCategorySection: true,
  showVisaCategoriesSection: true,
};

const MEETING_REPORT_UI_CONFIG: Partial<Record<MeetingId, MeetingReportUIConfig>> = {
  [MeetingId.VISA_ARCHITECT_INTAKE]: {
    showVoiceWhatsappToggle: false,
    defaultReportType: 'whatsapp',
    showExportCsv: false,
    showCallTypeColumn: false,
    showVisaCategoryColumn: false,
    showVisaCategorySection: false,
    showVisaCategoriesSection: false,
  },
};

export function getMeetingReportUIConfig(meetingId: string | undefined): MeetingReportUIConfig {
  if (!meetingId) return defaultConfig;
  return MEETING_REPORT_UI_CONFIG[meetingId as MeetingId] ?? defaultConfig;
}
